import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, ButtonGroup, IconButton, Menu, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { MenuMultiSelectItem } from 'shared/domains/common-ui/SearchableMenu';
import { useFuse } from 'shared/domains/common-utils/useFuse';
import { getDocumentMetadataGroups } from '../../utils/getDocumentMetadataGroups';
import { useSearchContext } from '../SearchProvider';
export function AddFilterButton(props) {
    const { filterItems } = props;
    const [query, setQuery] = useState('');
    const { hasFilters, clearFilters, toggleFilter, activeFilters } = useSearchContext();
    const { result, search, active } = useFuse(filterItems, { keys: ['name'], minMatchCharLength: 2 });
    const noResults = active && result.length === 0;
    const activeSearch = active && query.length >= 2;
    const groupedFilterItems = getDocumentMetadataGroups(filterItems);
    if (filterItems.length === 0)
        return null;
    const handleSearch = (value) => {
        setQuery(value);
        search(value);
    };
    const renderGroup = (group) => (<Menu.ItemNested key={group.key} target={group.label}>
      {group.properties.map((item) => (<MenuMultiSelectItem key={item.id} selected={activeFilters.includes(item.id)} onClick={() => toggleFilter(item.id)}>
          {group.key === 'remaining' ? `${item.id}__${item.name}` : item.name}
        </MenuMultiSelectItem>))}
    </Menu.ItemNested>);
    const renderNestedGroup = (group) => (<Menu.ItemNested key={group.key} target={group.label}>
      {group.groups.map((subGroup, index) => (<Fragment key={subGroup.key}>
          {index > 0 && <Menu.Divider />}
          <Menu.Label>{subGroup.label}</Menu.Label>
          {subGroup.properties.map((item) => (<MenuMultiSelectItem key={item.id} selected={activeFilters.includes(item.id)} onClick={() => toggleFilter(item.id)}>
              {item.name}
            </MenuMultiSelectItem>))}
        </Fragment>))}
    </Menu.ItemNested>);
    return (<ButtonGroup>
      <Menu.Root target={<Button type="button" size="small" appearance="secondary">
            <Falcon icon="plus"/>
            <Trans comment="Search: Add filter menu button">Filters</Trans>
          </Button>}>
        <Menu.HeaderSearch value={query} onChange={handleSearch} placeholder={t({
            message: 'Find metadata property...',
            comment: 'Search filters: Metadata filter search placeholder',
        })}/>

        {noResults && (<Box p="md" mb="sm">
            <Typography $appearance="100" $fontSize="small">
              <Trans comment="Search filters: No results found">No properties found</Trans>
            </Typography>
          </Box>)}

        {activeSearch
            ? result.map((item) => (<MenuMultiSelectItem key={item.id} selected={activeFilters.includes(item.id)} onClick={() => toggleFilter(item.id)}>
                {item.name}
              </MenuMultiSelectItem>))
            : groupedFilterItems.map((group) => (group.type === 'group' ? renderGroup(group) : renderNestedGroup(group)))}
      </Menu.Root>

      {hasFilters && (<IconButton appearance="secondary" size="small" onClick={clearFilters} aria-label={t({ message: 'Remove all filters', comment: 'Filters: Clear all filters' })}>
          <Falcon icon="remove"/>
        </IconButton>)}
    </ButtonGroup>);
}
